module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_8_4.bdc7edbd.jpg";